import * as yup from 'yup';

export enum DonationSourceType {
  Vehicle = 0,
  Cash = 1,
  OtherAssets = 2,
}

export interface DonationSource {
  Id: string | null;
  Type: DonationSourceType | null;
  Name: string;
  Value: number;
  IsSimulatedSource: boolean;
  SimulatedAccountType: number;
  EntityId: string;
}

export enum DonorType {
  Principal,
  Spouse,
}

export interface Donation {
  SourceId: string | null;
  SourceType: DonationSourceType | null;
  SourceName: string | null;
  RecipientId: string | null;
  RecipientName: string | null;
  DonationAmount: number | null;
  IsSimulatedSource: boolean;
  SimulatedAccountType: number | null;
  EntityId: string | null;
  Donor: DonorType;
  IsApplied: boolean;
}

export interface Recipient {
  Name: string;
  Id: string;
}

export interface WhatIfDTO {
  Donations: Donation[];
  GoalId: string;
  WhatIfType: 1402;
  WhatIfKey: '1402';
  WhatIfTypeName: 'EstatePlanningCharitableDonations';
  IsInvalidated: boolean;
}

export interface DonationSources {
  InEstate: DonationSource[];
  OutOfEstate: DonationSource[];
}

export interface Options {
  HasSpouse: boolean;
  DonorOptions: { Label: string; Value: DonorType }[];
  Recipients: Recipient[];
  PrimaryDonationSources: DonationSources;
  SpouseDonationSources: DonationSources | null;
}

export interface FormValues extends WhatIfDTO {}

export const FORM_SCHEMA = yup.object().shape({
  Donations: yup.array().of(
    yup.object().shape({
      SourceId: yup
        .string()
        .nullable()
        .required('This field is required'),
      RecipientName: yup
        .string()
        .nullable()
        .required('This field is required'),
      DonationAmount: yup
        .string()
        .nullable()
        .required('Please, specify an amount'),
    }),
  ),
});
